import React, { useState } from 'react';
import { AnyIfEmpty, useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { AppDispatch } from '../../../redux/rootReducer';
import iconClose from '../../../images/icon-close.svg';
import styles from '../DeleteVendorAppointmentModal/DeleteVendorAppointmentModal.module.css'
import { deleteVendorAppointment } from '../../../redux/vendor/actions/vendor.action';
import { getVisits } from '../../../redux/visits/actions/visits.action';
import Loader from '../loader/Loader';

const DeleteVendorAppointmentModal = ({ calendarInfo, setShowDeleteModal, locationId, setShowVendorAppointmentModal, startDate, endDate }: AnyIfEmpty<object>) => {
    const navigate = useNavigate();
    const dispatch: AppDispatch = useDispatch();
    const closeModal = () => setShowDeleteModal(false);
    const [isDeleting, setIsDeleting] = useState(false);

    const vendorId = calendarInfo?.id;
    const onDelete = () => {
        if (!vendorId || isDeleting) return;

        setIsDeleting(true);

        dispatch(
            deleteVendorAppointment(
                vendorId,
                (msg) => {
                    dispatch(getVisits(locationId, startDate, endDate));
                    setIsDeleting(false);
                    closeModal();
                    setShowVendorAppointmentModal(false);
                },
                () => {
                    setIsDeleting(false);
                }
            )
        );
    };

    return (

        <div className={styles.modalRemoveStaff}>
            {isDeleting && <Loader />}
            <div className={styles.modalHeader}>
                <div className={styles.modalTitle}>Delete Vendor Appointment</div>
                <span className={styles.close}>
                    <img src={iconClose} onClick={closeModal} alt="Close" />
                </span>
            </div>

            <div className={styles.modalBody}>
                <h2 className={styles.modalBodyTitle}>
                    Are you sure you want to cancel this vendor appointment?
                </h2>
            </div>

            <div className={styles.modalFooter}>
                <button
                    type="button"
                    onClick={closeModal}
                    className={`${styles.Modalbtn} ${styles.cancelBtn}`}
                >
                    Cancel
                </button>
                <button
                    type="submit" onClick={onDelete}
                    className={`${styles.Modalbtn} ${styles.deleteBtn}`}
                >
                    Delete
                </button>
            </div>
        </div>
    );
};

export default DeleteVendorAppointmentModal;
